import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const DirectionsTitle = () => <Title title='Directions (Optional)'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>